import React, { FC } from 'react'
import cx from 'classnames'
import { isNotFalse } from '@feedyou/utils'
import { FadingCircle } from 'styled-spinkit'

import { DropdownMenuItem } from './Item/types'
import { renderItem } from './Item/Item'
import { DropdownBackground } from '../DropdownBackground'
import { hasSubItems } from './utils'

export type Props = {
  items: (DropdownMenuItem | false)[]
  className?: string
  stopClickPropagation?: boolean
  onClick?: () => void
  'data-test'?: string
}

const DropdownMenuList: FC<Props> = ({
  items,
  className,
  stopClickPropagation = false,
  onClick,
  'data-test': dataTest
}) => {
  const validItems = items.filter(isNotFalse)

  const subitemsExist = hasSubItems(validItems)

  if (!validItems?.length) {
    return null
  }

  return (
    <DropdownBackground
      onClick={e => {
        onClick?.()
        stopClickPropagation && e.stopPropagation()
      }}
      className={className}
      data-test={cx('dropdown-menu', dataTest && `${dataTest}-menu`)}
    >
      {validItems.map(item =>
        item?.isLoading ? (
          <FadingCircle size={18} color="blue" />
        ) : (
          <>{renderItem(item, subitemsExist, onClick)}</>
        )
      )}
    </DropdownBackground>
  )
}

export default DropdownMenuList
